import { AlertTriangle } from 'lucide-react';

/** Cloud forensic-container accept list. Mirrors `FORENSIC_UPLOAD_EXTS` in backend `api/v1/cases.py`. */
export const FORENSIC_UPLOAD_EXTS = ['.ufdr', '.e01', '.zip', '.ab'] as const;

/**
 * The cloud image does not install libewf (requirements-offline-e01.txt).
 * The API still accepts a .e01 name; on the hosted platform that parse fails.
 * The upload screens say this so an officer does not bring an EnCase image.
 */
export const HOSTED_FORENSIC_NOTE =
    'On the hosted platform upload a Cellebrite .ufdr. EnCase .e01 opens in the offline build; the cloud image does not include libewf.';

/** Same wording as the backend 415 detail, so the client check and the server agree. */
export const UFD_REJECT_MESSAGE =
    'A .ufd is a Cellebrite descriptor, not the extraction. Upload the .ufdr or the dump .zip it lists, or run the offline CryptoScan exe on the folder.';

/** Returns the rejection message for a `.ufd` file name, else null. */
export function forensicNameError(fileName: string): string | null {
    return fileName.trim().toLowerCase().endsWith('.ufd') ? UFD_REJECT_MESSAGE : null;
}

export const PARTIAL_BANNER_TEXT =
    'Partial result — budget reached; run the offline exe for a full scan';

/** Shown when a parse response / `complete` event carries `partial: true`. */
export function ForensicPartialBanner({ partial, reason }: { partial?: boolean | null; reason?: string | null }) {
    if (!partial) return null;
    return (
        <div
            role="status"
            data-testid="forensic-partial-banner"
            className="bg-amber-500/10 border border-amber-500/30 rounded-md p-3 flex gap-3"
        >
            <AlertTriangle className="h-5 w-5 text-amber-500 shrink-0" />
            <div className="space-y-1">
                <p className="text-xs font-bold text-amber-500 uppercase tracking-tight">{PARTIAL_BANNER_TEXT}</p>
                {reason && <p className="text-[11px] text-muted-foreground">{reason}</p>}
            </div>
        </div>
    );
}
